// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3a561b20] .info {\n  padding: 0.13333rem;\n  padding-top: 0.26667rem;\n  height: calc(100% - 1.33333rem);\n  overflow-y: auto;\n}\n[data-v-3a561b20] .tips-larger {\n  font-size: 0.48rem;\n}\n[data-v-3a561b20] .tips-larger, .tips-middle[data-v-3a561b20] {\n  font-weight: 600;\n}\n[data-v-3a561b20] .card-content {\n  padding-top: 0 !important;\n}\n[data-v-3a561b20] .t1 {\n  height: 1.06667rem;\n  line-height: 1.06667rem;\n  margin-left: 30%;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
